import React, { useEffect, useMemo } from 'react';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import './index.scss';
// value 选中的值
// disabled 是否禁用
// indeterminate 是否半选
// onChange 选择事件
// color 颜色
const FollowMultipleChoice = (props: any) => {
  const {
    onChange,
    color = ECHARTSCOLOR[0],
    checkList,
    name,
    groupList,
    isAll = false,
    isSubTableAll = false,
    DEFAULT_GROUPNAME,
  } = props;

  // console.log('FollowMultipleChoice', props);
  // console.log('namenamename~~~~~~~~~~~~~~~~~~~~~~~~~~~~', name);

  const checkTrueList = useMemo(() => {
    if (isAll && isSubTableAll) {
      const nameTrue = name?.replace(/\s*/g, '');
      if (Array.isArray(checkList)) {
        return checkList?.filter((item: any) => item?.includes(nameTrue));
      } else {
        return checkList
      }
    } else {
      return checkList
    }
  }, [checkList, name, isAll]);

  const groupTrueList = useMemo(() => {
    if (isAll) {
      if (Array.isArray(groupList)) {
        return groupList?.filter((item: any) => item.entity_name != 'My favourite');
      } else {
        return groupList;
      }
    } else {
      return groupList;
    }
  }, [groupList, isAll]);

  const checked = useMemo(() => {
    if (isAll) {
      return (groupTrueList?.length == checkTrueList?.length && checkTrueList?.length > 0);
    } else {
      return checkList?.includes(name);
    }
  }, [checkList, name, checkTrueList, groupTrueList]);

  const indeterminate = useMemo(() => {
    if (isAll) {
      return groupTrueList?.length == checkTrueList?.length ? false : checkTrueList?.length > 0 ? true : false;
    }
  }, [checkList, name, checkTrueList]);

  return (
    <input
      type="checkbox"
      className={`${indeterminate ? 'dbi-table-indeterminate' : ''} ${checked ? 'dbi-table-check' : 'dbi-table-nocheck'
        }`}
      checked={checked}
      style={{
        backgroundColor: checked || indeterminate ? color : '',
        borderColor: checked || indeterminate ? color : '',
      }}
      onChange={() => {
        onChange(!checked);
      }}
      disabled={name == DEFAULT_GROUPNAME || name == 'My favourite'}
    />
  );
};

export default FollowMultipleChoice;